import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function Rd2sReducer(state = initialState.flags, action: any) {
  switch (action.type) {
    case types.SAVE_FLAGS_SUCCESS:
      return action.flags;
    default:
      return state;
  }
}
